import React from 'react';
import classNames from 'classnames';

import css from './IconCouch.module.css';

/**
 * IconCouch icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconCouch = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.02424 8.86326V6.11927C1.02424 5.25326 1.72623 4.55123 2.59223 4.55127H10.8242C11.0407 4.55127 11.2162 4.72677 11.2162 4.94327V12.3913H5.72824C5.72824 10.6593 4.3242 9.25527 2.59223 9.25527H1.41623C1.19974 9.25527 1.02424 9.07976 1.02424 8.86326ZM21.4082 9.25527H22.5842C22.8007 9.25527 22.9762 9.07976 22.9762 8.86326V6.11927C22.9762 5.25332 22.2742 4.55131 21.4082 4.55127H13.1762C12.9597 4.55127 12.7842 4.72677 12.7842 4.94327V12.3913H18.2722C18.2722 10.6593 19.6763 9.25527 21.4082 9.25527ZM22.1922 10.8233H21.4082C20.5422 10.8233 19.8402 11.5253 19.8402 12.3913V13.1753C19.8402 13.6083 19.4892 13.9593 19.0562 13.9593H4.94423C4.51123 13.9593 4.16023 13.6083 4.16023 13.1753V12.3913C4.16023 11.5253 3.45821 10.8233 2.59223 10.8233H1.80823C0.942253 10.8233 0.240234 11.5253 0.240234 12.3913V15.5273C0.240234 16.3933 0.942225 17.0953 1.80823 17.0953H2.59223V18.6368C2.58603 19.0571 2.90553 19.4108 3.32429 19.4473C3.77741 19.4773 4.16123 19.1174 4.16023 18.6633V17.0953H19.8402V18.6368C19.8346 19.0565 20.1541 19.4094 20.5723 19.4453C21.0254 19.4754 21.4092 19.1154 21.4082 18.6613V17.0953H22.1922C23.0582 17.0953 23.7602 16.3932 23.7602 15.5273V12.3913C23.7602 11.5253 23.0582 10.8233 22.1922 10.8233Z" fill="#262338"/>
</svg>

  );
};

export default IconCouch;
